import { track } from "../telemetry/emit";
import { updates } from "./updates.svelte";

export interface PageLoadRecovery {
  claimChunkReload: () => boolean;
  markPostReload: () => void;
  reload: () => void;
  trackChunkError: (route: string, recovered: boolean) => void;
}

const reloadPending = new Promise<never>(() => {});

const defaultRecovery: PageLoadRecovery = {
  claimChunkReload: () => updates.claimChunkReload(),
  markPostReload: () => updates.markPostReload(),
  reload: () => {
    if (typeof window !== "undefined") window.location.reload();
  },
  trackChunkError: (route, recovered) => {
    track({ name: "release.chunk_error", route, recovered });
  }
};

/**
 * Loads a route chunk and gives a stale tab one guarded reload attempt. The first
 * failed promise remains pending while navigation replaces the document; a second
 * failure rejects to the shell's error surface instead of creating a reload loop.
 */
export async function loadPage<T>(
  route: string,
  loader: () => Promise<T>,
  recovery: PageLoadRecovery = defaultRecovery
): Promise<T> {
  try {
    return await loader();
  } catch (error) {
    const recovered = recovery.claimChunkReload();
    recovery.trackChunkError(route, recovered);

    if (!recovered) throw error;

    recovery.markPostReload();
    try {
      recovery.reload();
    } catch {
      throw error;
    }
    return reloadPending;
  }
}
